import React, {useEffect} from "react";
import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";

import {createIdea, selectIdeasStatus} from "store/currentBoardSlice";
import {closeModal} from "store/modalsSlice";

import Button from "layout/atoms/Button";
import ContentBox from "layout/atoms/ContentBox";
import Form from "layout/atoms/Form";
import InputText from "layout/atoms/InputText";
import Modal from "layout/atoms/Modal";

const AddIdeaModal = ({ boardId }) => {
  const dispatch = useDispatch();
  const { addIdea: addStatus } = useSelector(selectIdeasStatus);
  const { t } = useTranslation("translation", {
    keyPrefix: "boardsDetails.forms.addIdea",
  });
  const { t: tGeneral } = useTranslation("translation");
  const {
    register,
    handleSubmit,
    formState,
    formState: { errors, isSubmitSuccessful },
    reset,
  } = useForm({ defaultValues: { title: "", description: "" } });

  const handleClose = () => dispatch(closeModal("addIdeaModal"));

  const handleCreate = (data) => {
    dispatch(createIdea({ data, boardId }))
      .unwrap()
      .then(() => {
        reset();
        handleClose();
      })
      .catch(() => console.log("Error toast"));
  };

  useEffect(() => {
    if (formState.isSubmitSuccessful) reset();
  }, [formState.isSubmitSuccessful, reset]);

  return (
    <Modal open onClose={handleClose}>
      <ContentBox size="m" header={<h3>{t("header")}</h3>}>
        <Form onSubmit={handleSubmit(handleCreate)}>
          <InputText
            type="text"
            name="title"
            label={t("fields.title.label")}
            placeholder={t("fields.title.placeholder")}
            register={register}
            errors={errors.title}
            validation={{ required: true, minLength: 6, maxLength: 100 }}
          />
          <InputText
            type="textarea"
            name="description"
            label={t("fields.description.label")}
            placeholder={t("fields.description.placeholder")}
            register={register}
            errors={errors.description}
            validation={{ minLength: 6, maxLength: { value: 10000, message: tGeneral("formErrors.tooLong") } }}
          />
          <div>
            <Button type="button" size="lg" color="white" onClick={() => { reset(); handleClose(); }} disabled={addStatus === "loading"}>
              {t("buttons.cancel")}
            </Button>
            <Button type="submit" size="lg" color="primary" loading={addStatus === "loading"}>
              {t("buttons.save")}
            </Button>
          </div>
        </Form>
      </ContentBox>
    </Modal>
  );
};

AddIdeaModal.propTypes = {
  boardId: PropTypes.string,
};

export default AddIdeaModal;
